// extracted by mini-css-extract-plugin
export var actionText = "_rg-4";
export var container = "_rg-0";
export var leftSection = "_rg-1";
export var rightSection = "_rg-2";
export var settingsButton = "_rg-6";
export var settingsIcon = "_rg-7";
export var shortcut = "_rg-5";
export var shortcutGroup = "_rg-3";